import { SemanticCOLORS, SemanticICONS } from 'semantic-ui-react';
import { StatoChiamata, StatoFiltroChiamate } from './models';

export interface StatoValues {
    stato: StatoChiamata,
    name: SemanticICONS,
    color: SemanticCOLORS,
    text: string
}

export interface StatoFiltroValues {
    stato: StatoFiltroChiamate,
    name: SemanticICONS,
    color: SemanticCOLORS,
    text: string
}

export function getStatoValues(stato: StatoChiamata): StatoValues {
    return allStatiValues.find(s => s.stato === stato)!;
}

const allStatiValues: StatoValues[] = [
    { stato: StatoChiamata.Inviato, name: 'send', color: 'teal', text: 'Inviato' },
    { stato: StatoChiamata.PresoInCarico, name: 'unhide', color: 'purple', text: 'In carico' },
    { stato: StatoChiamata.InCorso, name: 'play', color: 'blue', text: 'In corso' },
    { stato: StatoChiamata.Chiuso, name: 'checkmark box', color: 'green', text: 'Chiuso' },
    { stato: StatoChiamata.Rifiutato, name: 'window close outline', color: 'red', text: 'Rifiutato' },
    { stato: StatoChiamata.AttesaRicambi, name: 'cogs', color: 'orange', text: 'Attesa ricambi' },
]

export const allStatiFiltroValues: StatoFiltroValues[] = [
    { stato: StatoFiltroChiamate.Aperta, name: 'calendar check outline', color: 'green', text: 'Aperte' },
    { stato: StatoFiltroChiamate.Inviato, name: 'send', color: 'teal', text: 'Inviate' },
    { stato: StatoFiltroChiamate.PresoInCarico, name: 'unhide', color: 'purple', text: 'In carico' },
    { stato: StatoFiltroChiamate.InCorso, name: 'play', color: 'blue', text: 'In corso' },
    { stato: StatoFiltroChiamate.Chiuso, name: 'checkmark box', color: 'green', text: 'Chiuse' },
    { stato: StatoFiltroChiamate.Rifiutato, name: 'window close outline', color: 'red', text: 'Rifiutate' },
    { stato: StatoFiltroChiamate.AttesaRicambi, name: 'cogs', color: 'orange', text: 'Attesa ricambi' },
]